import Vue from 'vue';
import Router from 'vue-router';
import pc from './pc';
Vue.use(Router);
const baseRouter = [];
function combineRouter(routers) {
  return routers.reduce((pre, cur) => pre.concat(cur), baseRouter);
}
const pageRouters = [
  pc,
];
const router = new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: combineRouter(pageRouters),
});
export default router;
